var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":_vm.$t('general.People'),"active":""}},[_c('People')],1),_c('b-tab',{attrs:{"title":_vm.$t('general.Businesses')}},[_c('Businesses')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }